<template>
    <div>
        <v-checkbox
            v-model="filterHosp"
            label="Filter Hospital/Clinic by Location"
            @change="handleChangeFilterFromHosp($event)"
        />
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    props: ['to', 'member_model', 'loading'],
    data: ()=>({
        filterHosp: null
    }),
    watch: {
        filterHosp() {
            this.loading.to.hospital = true
        },
        'to.filter.hosp'(newVal) {
            if (newVal) this.filterHosp = newVal
        }
    },
    methods: {
        ...mapActions(['toProvinces', 'toCities', 'toHospClin']),
        handleChangeFilterFromHosp(value) {
            this.to.filter.hosp = value
            if (this.to.facility && value) {
                this.to.region = String(this.to.facility.hosp_region).trim()
                this.to.province = String(this.to.facility.city_province).trim()
                this.to.city = String(this.to.facility.city_name).trim()
            }
            if (!value) {
                this.to.region = ''
                this.to.province = ''
                this.to.city = ''
            }
            this.toProvinces({ REGION: this.to.region })
            this.toCities({ REGION: this.to.region, PROVINCE: this.to.province })
            this.toHospClin({ REGION: this.to.region, PROVINCE: this.to.province, CITY: this.to.city, TYPE: '', MEMBN: this.member_model.MEMB_N })
        }
    }
}
</script>
